import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { createStructuredSelector } from 'reselect';
import Dashboard from '../../../../component/Dashboard';
import { createWhiteListedIPs, doCreateWhiteListedIPsRes } from '../../../../actions/whitelistedIPsActions';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import validate from './formValidation';
class AddWhiteListedIPForm extends React.Component { 
  constructor() {
    super();
    this.state = {
      hostIP: '',
      description: '',
      tabIndex: 0,
      isSubmitted: false,
    }
  }
  componentDidMount() {
    this.setState({
      tabIndex: this.props.location.state.tabIndex
    });
  }
  static getDerivedStateFromProps(props, state) {
		if (props.createWhiteListedIPsRes) {
      if (props.createWhiteListedIPsRes.data && props.createWhiteListedIPsRes.data.whiteListedIPs) {
        if (props.createWhiteListedIPsRes.data.whiteListedIPs.message === "Success") {
          props.history.push({
            pathname: `/system-setting`,
            state: {
                tabIndex: state.tabIndex,
            }
          });
        }
      }
    }
		return null
	}
  
  goBack = () => {
    this.props.history.push({
      pathname: `/system-setting`,
      state: {
          tabIndex: this.state.tabIndex,
      }
    });
  }
  saveWhiteListedIP = () => {
    this.setState({
      isSubmitted: true,
    }, () => { });
    validate(this.state);
    const errors = validate(this.state);
    
    if (Object.keys(errors).length === 0) {
      let payload = {
        ip_host: this.state.hostIP,
        description: this.state.description,
      }
      this.props.handleFormSubmit(payload);
    } 
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  render() {
    const errors = validate(this.state);
    return (
      <Dashboard title="ClickIPO System Setting- Add whiteListed IP" pageTitle="Create whiteListed IP">
        <div className="admin_offering_content">
          <div className="">
            <div  className="Headingname">
              <ArrowBackIosIcon onClick={() => this.goBack()} style={{ cursor: 'pointer' }} /> Back
            </div>
            <form autoComplete="off"  style={{ marginTop: 30 }}>
              <div className="row">
                <div className="col-md-12 col-sm-12"  style={{ marginTop: 20 }}>
                  <TextField name="hostIP" fullWidth label="Host IP" onChange={this.handleChange} />
                  {errors && this.state.isSubmitted && <span className="errorvalidation">{errors.hostIP}</span>}
                </div>
                <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                  <TextField multiline name="description" fullWidth label="Description" onChange={this.handleChange} />
                  {errors && this.state.isSubmitted && <span className="errorvalidation">{errors.description}</span>}
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-md-12" style={{ textAlign: 'center' }}>
                <Button variant="contained" color="primary" onClick={this.saveWhiteListedIP} style={{ marginTop: '30px' }} >Submit</Button>
              </div>
            </div>
          </div>
        </div>
      </Dashboard>
    );
  }
}

AddWhiteListedIPForm.propTypes = {
  createWhiteListedIPsRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  createWhiteListedIPsRes: doCreateWhiteListedIPsRes,
});

function mapDispatchToProps(dispatch) {
  return {
    handleFormSubmit: (data) => dispatch(createWhiteListedIPs(data)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddWhiteListedIPForm);
